export default __webpack_public_path__ + "static/media/NeverWet.aa1331d0.jpg";